import React, { useState, useEffect } from 'react'
import { CssBaseline, Box } from '@material-ui/core'
import { ThemeProvider } from '@material-ui/core/styles'
import { navigate } from '@reach/router'

import { theme } from '../../theme'
import { firebaseAuthUser } from '../../firebase/auth'

export default function AuthLayout(props) {
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  const { children } = props

  /**
  |--------------------------------------------------
  | States
  |--------------------------------------------------
  */
  const [loading, setLoading] = useState(true)

  /**
  |--------------------------------------------------
  | Fetch Auth User
  |--------------------------------------------------
  */
  async function fetchAuthUser() {
    try {
      setLoading(true)

      const user = await firebaseAuthUser()
      if (user) {
        navigate(`/`)
      }

      setLoading(false)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    fetchAuthUser()
  }, [])

  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */
  if (loading) {
    return <Box bgcolor="grey.800" height="100vh"></Box>
  }

  return (
    <ThemeProvider theme={theme}>
      <Box display="flex">
        <CssBaseline />
        {children}
      </Box>
    </ThemeProvider>
  )
}
